<template>
  <div>
    <v-overlay :opacity="1" :value="overlay" class="default_overlay" z-index="21">
      <Loading />
    </v-overlay>
    <v-app id="service-page-app">
      <v-main>
        <ServicePageHeader />
        <slot />
      </v-main>
      <ErrorModal />
      <UnsupportedBrowserModal id="unsupported-browser-modal" />
      <AppLockOverlay v-if="$store.getters['appLock/isAppLockEnabled']" />
    </v-app>
  </div>
</template>

<script>
import AppLockOverlay from '@/feature/app-lock/components/AppLockOverlay.vue';

export default {
  name: 'ServicePageLayout',
  components: { AppLockOverlay },
  data() {
    return {
      overlay: true
    };
  },
  mounted() {
    this.overlay = false;
  }
};
</script>

<style lang="scss">
body .v-overlay--active.default_overlay {
  .v-overlay__scrim {
    opacity: 1 !important;
    background-color: $white !important;
    border-color: $white !important;
  }
}

#service-page-app {
  background-color: #f2f6f9;
}
</style>
